'use client';

import { useEffect, useRef } from 'react';
import {
  useGetOrCreateOnboardingSessionQuery,
} from '@/api/features/onboarding';
import type { OnboardingSession } from '@/api/features/onboarding';
import { useTour } from '../hooks/useTour';

/**
 * Render-less hook that auto-starts the AdminTour when
 * the onboarding session's currentStep is 'demo'.
 *
 * Mount once in DashboardShell (or as a component wrapper).
 */
export function useAdminTourAutoStart() {
  const { startTour, activeTourId } = useTour();
  const startedRef = useRef(false);

  const { data: session } = useGetOrCreateOnboardingSessionQuery(undefined, {
    refetchOnFocus: false,
    refetchOnMountOrArgChange: false,
  });

  const currentOnboardingStep = (session as OnboardingSession | undefined)?.currentStep as
    | string
    | undefined;

  useEffect(() => {
    if (currentOnboardingStep === 'demo' && !activeTourId && !startedRef.current) {
      startedRef.current = true;
      startTour('admin');
    }
  }, [currentOnboardingStep, activeTourId, startTour]);
}

/**
 * Render-less component wrapper for useAdminTourAutoStart.
 * Use in JSX: <AdminTourAutoStart />
 */
export function AdminTourAutoStart() {
  useAdminTourAutoStart();
  return null;
}
